import styled, { css } from "styled-components";

const variants = {
  solid: css`
    background: ${({ theme }) => theme.colors.landing?.accent?.primary || theme.colors.primary.light};
    color: white;
    border: 1px solid transparent;
    box-shadow: 0 4px 16px ${({ theme }) => theme.colors.landing?.accent?.glow || "rgba(155, 135, 245, 0.3)"};

    &:hover {
      background: ${({ theme }) => theme.colors.landing?.accent?.hover || theme.colors.primary.hover};
      transform: translateY(-2px) scale(1.02);
      box-shadow: 0 12px 32px ${({ theme }) => theme.colors.landing?.accent?.glow || "rgba(155, 135, 245, 0.4)"};
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  `,
  outline: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.landing?.accent?.primary || theme.colors.primary.light};
    border: 2px solid ${({ theme }) => theme.colors.light?.primary || theme.colors.landing?.glass?.border || theme.colors.border}40;

    &:hover {
      background: ${({ theme }) => theme.colors.light?.primary || "rgba(155, 135, 245, 0.12)"}12;
      border-color: ${({ theme }) => theme.colors.light?.primary || theme.colors.landing?.accent?.primary || theme.colors.primary.light}80;
      color: ${({ theme }) => theme.colors.light?.foreground || theme.colors.landing?.text?.primary || "white"};
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  `,
  ghost: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.text.body};
    border: 1px solid transparent;

    &:hover {
      background: rgba(155, 135, 245, 0.08);
      color: ${({ theme }) => theme.colors.primary.light};
    }
  `,
  hero: css`
    background: ${({ theme }) => theme.colors.gradients.primary};
    color: white;
    border: none;
    font-weight: 700;
    box-shadow: ${({ theme }) => theme.shadows.glow};
    background-size: 200% 200%;
    animation: gradient-shift 8s ease infinite;

    &:hover {
      opacity: 0.9;
      transform: scale(1.05);
    }

    &:active {
      transform: scale(1);
    }
  `,
  gradient: css`
    background: ${({ theme }) => theme.colors.gradients.primary};
    color: white;
    border: none;
    box-shadow: ${({ theme }) => theme.shadows.soft};
    background-size: 200% 200%;
    animation: gradient-shift 8s ease infinite;

    &:hover {
      opacity: 0.9;
      box-shadow: ${({ theme }) => theme.shadows.glow};
    }
  `,
  "hero-outline": css`
    border: 2px solid ${({ theme }) => theme.colors.light?.primary || "hsl(258, 90%, 58%)"}50;
    background: ${({ theme }) => theme.colors.glass?.light?.background || "hsla(0, 0%, 100%, 0.5)"};
    backdrop-filter: blur(10px);
    color: ${({ theme }) => theme.colors.light?.foreground || theme.colors.text.heading};
    font-weight: 700;

    &:hover {
      background: ${({ theme }) => theme.colors.light?.primary || "hsl(258, 90%, 58%)"}10;
      border-color: ${({ theme }) => theme.colors.light?.primary || "hsl(258, 90%, 58%)"}80;
    }
  `,
};

const sizes = {
  sm: css`
    height: 36px;
    padding: 0 12px;
    font-size: 14px;
  `,
  md: css`
    height: 40px;
    padding: 0 14px;
    font-size: 14px;
  `,
  lg: css`
    height: 48px;
    padding: 0 20px;
    font-size: 15px;
  `,
  xl: css`
    height: 64px;
    padding: 0 40px;
    font-size: 18px;
    border-radius: 16px;
  `,
  icon: css`
    height: 40px;
    width: 40px;
    padding: 0;
  `,
};

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: ${({ $size }) => ($size === "xl" ? "16px" : "9999px")};
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  outline: none;
  transition: all 0.3s ${({ theme }) => theme.animations?.easing?.default || "cubic-bezier(0.4, 0, 0.2, 1)"};
  white-space: nowrap;

  ${({ $variant }) => variants[$variant || "solid"]}
  ${({ $size }) => sizes[$size || "md"]}
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
`;

